// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"fec35600","518":"0f14c915","674":"d7811b66","861":"dad99619","995":"96fa3510"}[chunkId] + ".chunk.css";
};